/* KCI Event Tagging — shared enums, labels and the reason "signal" palette.
   Enum values are the backend contract (KCI_API_DOC §2); labels are the UI copy.
   Keep this the single source of truth so every screen maps the same way. */

// ── Reason category — value ⇄ label ⇄ signal colour (KCI_API_DOC §2) ──────────
export const REASON_CATEGORIES = [
  { value: 'WEATHER', label: 'Weather', color: '#0EA5E9' },
  { value: 'RELIGIOUS_FESTIVAL', label: 'Religious / Festival', color: '#C026D3' },
  { value: 'POLITICAL_CIVIC', label: 'Political / Civic', color: '#DB2777' },
  { value: 'INFRASTRUCTURE', label: 'Infrastructure', color: '#64748B' },
  { value: 'COURIER_INTERNAL', label: 'Courier-Internal', color: '#4338CA' },
  { value: 'ROUTE_LINEHAUL', label: 'Route / Linehaul', color: '#0D9488' },
  { value: 'ADMINISTRATIVE', label: 'Administrative', color: '#B45309' },
  { value: 'OTHER', label: 'Other', color: '#94A3B8' },
]
export const reasonLabel = (v) => REASON_CATEGORIES.find((r) => r.value === v)?.label || v || '—'
export const reasonColor = (v) => REASON_CATEGORIES.find((r) => r.value === v)?.color || '#94A3B8'

// ── Direction (KCI_API_DOC §2) ────────────────────────────────────────────────
export const DIRECTIONS = [
  { value: 'FORWARD', label: 'Forward only' },
  { value: 'REVERSE', label: 'Reverse only (RTO / returns)' },
  { value: 'BOTH', label: 'Both forward & reverse' },
]
export const directionShort = (v) =>
  ({ FORWARD: 'Fwd only', REVERSE: 'Rev only', BOTH: 'Fwd & Rev' }[v] || v)

// ── Courier scope (KCI_API_DOC §2) ────────────────────────────────────────────
export const COURIER_SCOPE = { SPECIFIC: 'SPECIFIC_ACCOUNT', PARENT: 'PARENT_WIDE' }

// ── Geography type (KCI_API_DOC §2) ───────────────────────────────────────────
export const GEO_TYPE = { CITY: 'CITY', STATE: 'STATE', PIN: 'PINCODE_LIST', PAN: 'PAN_INDIA' }

// ── Impact type (KCI_API_DOC §2) ──────────────────────────────────────────────
// Only the two values that actually change behaviour are offered. The backend enum also
// carries PAUSE and MIXED, but nothing branches on them — they tag shipments and apply the
// custom EDD exactly like TAT_EXTENSION, so offering them would let ops pick an option
// that silently does nothing. Add one back only once it has defined behaviour.
export const IMPACT_TYPES = [
  { value: 'TAT_EXTENSION', label: 'Tag Order as KCI Impacted', desc: "Updated EDD is logged and notified, but doesn't impact performance metrics in ProShip." },
  { value: 'INFORMATIONAL_ONLY', label: 'Informational only', desc: 'No order tagging or notification.' },
]

// ── Event status → MUI chip colour (KCI_API_DOC §2) ───────────────────────────
export const STATUS_COLOR = {
  DRAFT: 'default',
  SCHEDULED: 'info',
  ACTIVE: 'success',
  EXTENDED: 'success',
  CLOSED: 'default',
  EXPIRED: 'warning',
}
